/** Opens and closes the mobile navigation with the burger button of the header */
export function initMobileNav() {
    const burger = document.getElementById('nav-burger')
    burger?.addEventListener('click', () => {
        document.querySelectorAll('.mobile-nav').forEach(element => element.classList.toggle('active'))
        burger.classList.toggle('active')
    })
}
